<kendo-card class="series-edit-banner" *ngIf="isEdititingMeetingSeries">
        <div>You are currently editing a meeting series.</div>
        <!-- <button kendoButton fillMode="link" [themeColor]="'primary'" (click)="isEditingSession = false">
            Edit Series
        </button> -->
</kendo-card>

<kendo-card class="series-edit-banner" *ngIf="isEditingSession === false">
    <div>You are currently editing a series.</div>
</kendo-card>

<kendo-card class="series-edit-banner" *ngIf="showSessionSeriesBanner">
    <div>You are currently editing a session of a series.</div>
</kendo-card>


<kendo-dialog-titlebar>
    <div class="k-d-flex k-justify-content-space-between k-align-items-center title">
        <fa-icon [icon]="['far', 'calendar']" class="k-mr-2" style="font-size: 24px;"></fa-icon>
        <h4 #scheduleTimeDialogFocus tabindex="-1" class="k-m-0" style="color: var(--tb-kendo-neutral-160)">Schedule Time</h4>
    </div>
</kendo-dialog-titlebar>
<kendo-tabstrip (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab [selected]="scheduleTiimeSelected" [hidden]="showScheduleAssignmentBtn && !selectionCompare">
        <ng-template kendoTabTitle>
            Details
        </ng-template>
        <ng-template kendoTabContent>
            <div role="group" class="k-h-full">
            <app-schedule-details *ngIf="!studentsSelected" [providerManagementInfo]="providerManagementInfo"
                [isEditingSession]="isEditingSession" [isNew]="isNew"
                [showAbsencePeriodForCreate]="fromCreateServiceEntry"
                [isEdititingMeetingSeries]="isEdititingMeetingSeries" [startDate]="startDate" [startTime]="startTime"
                [endTime]="endTime" [selectedMandates]="selectedMandates" [clickEmptySchedule]="clickEmptySchedule"
                [meetingSk]="meetingSk" (mandateInfo)="onMandateInfo($event)"
                [displayScheduleTimeButton]="displayScheduleTimeButton" [studentsSelected]="studentsSelected"
                [selecteStudentdMandates]="selecteStudentdMandates" [recurringMeetingSk]="recurringMeetingSk"
                [addSelectionToGroup]="addSelectionToGroup" [schedulerPopupOpen]="schedulerPopupOpen"
                [isSchedulerAdd]="isSchedulerAdd" [editSelectedMandates]="editSelectedMandates" [fromEncounterAttendance]="fromEncounterAttendance"
                [selectedMandatesDetails]="selectedMandatesDetails" [indirectType]="indirectType"[openedFromInlineSchedule]="openedFromInlineSchedule"></app-schedule-details>

            <app-schedule-evaluation-dialogbox *ngIf="studentsSelected"
                [providerManagementInfo]="providerManagementInfo" [isEditingSession]="isEditingSession" [isNew]="isNew"
                [isEdititingMeetingSeries]="isEdititingMeetingSeries" [startDate]="startDate" [startTime]="startTime"
                [endTime]="endTime" [selectedMandates]="selectedMandates" [clickEmptySchedule]="clickEmptySchedule"
                [meetingSk]="meetingSk" (mandateInfo)="onMandateInfo($event)"
                [displayScheduleTimeButton]="displayScheduleTimeButton" [studentsSelected]="studentsSelected"
                [selecteStudentdMandates]="selecteStudentdMandates"
                [schedulerPopupOpen]="schedulerPopupOpen"></app-schedule-evaluation-dialogbox>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
     <!-- [hidden]="!isDisplayScheduleAssistant &&
     !showScheduleAssignmentBtn && !studentsSelected && !selectionCompare" -->
    <kendo-tabstrip-tab [selected]="!scheduleTiimeSelected" *ngIf="displayScheduleTimeButton 
    || showForAssignedStudent" 
    >
        <ng-template kendoTabTitle>
            Scheduling Assistant
        </ng-template>
        <ng-template kendoTabContent>
            <div role="group" class="k-h-full">
            <app-schedule-assisstant [selectedMandates]="selectedMandates" [studentsSelected]="studentsSelected"
                [isNew]="isNew" [meetingSk]="meetingSk" [annualGoalsGridView]="annualGoalsGridView"
                [compareMandatesGridView]="compareMandatesGridView" [selectionCompare]="selectionCompare"
                [selecteStudentdMandates]="selecteStudentdMandates" [editStartDate]="editStartDate" [studentSk]="studentSk"
                [editStartTime]="editStartTime" [scheduleFormDetails]="getScheduleDetailsFormGroup?.value" [isEditingSession]="isEditingSession" [editSelectedMandates]="editSelectedMandates"></app-schedule-assisstant>
       </div>
            </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
<!-- *ngIf="!selectionCompare" -->

<div class="time-spent-note" *ngIf="!showScheduleAssignmentBtn && selectedTabIndex === 0 && !studentsSelected && (scheduleDetailsCmp?.isTimeSpentSessionNotes || scheduleDetailsCmp?.isProgressReportingSession)">
    <p>Please note that scheduling this time will only block it on your calendar and mark it as unavailable. Billing will be based on the time you enter for each individual encounter, not the time scheduled here.</p>
</div>

<kendo-dialog-actions *ngIf="!showScheduleAssignmentBtn">

    <button *ngIf="selectedTabIndex === 0" kendoButton themeColor="primary" [disabled]="
    disableScheduleForm || scheduleWeekly "
            (click)="onScheduleTime()"><kendo-loader class="k-mr-3 loader" size="large"
                *ngIf="scheduleEditService.loading" size="small">
        </kendo-loader>{{(isNew || clickEmptySchedule)? 'Schedule' :
        'Update Scheduled Details'}}</button>
</kendo-dialog-actions>

<!-- &&showErrorPopup -->
<app-schedule-error-dailogbox *ngIf="showSchedulerError " [isNew]="isNew"
    (dialogClosed)="onChildDialogClosed($event); $event ? null : scheduleTimeDialogFocus.focus()" [getScheduleDetailsFormGroup]="getScheduleDetailsFormGroup"
    [isEditingSession]="isEditingSession" [scheduleDetailsCmp]="scheduleDetailsCmp"></app-schedule-error-dailogbox>